/*
 * decaffeinate suggestions:
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import isEmpty from "lodash/isEmpty";
import Analytics from "analytics/util/Analytics";
import BoostPackages from "shared/dictionaries/BoostPackages";
import { getStore } from "shared/redux/addToGlobalStore";
import {
	setBoostMultiplier,
	endBoost,
} from "ducks/navbar";
import OkC from "shared/util/OkcApi";
import _str from "shared/util/_str";
import _strf from "shared/util/_strf";
import Context from "shared/util/Context";
import { syncBoost } from "ducks/navbar";
import { BOOST_STATE } from "shared/constants/boosts";

const BOOST_V2_SYNCTIME = 10000;

window.BoostModel = {
	// constants
	states: Object.values(BOOST_STATE),

	data: {
		// passed in through params
		openboosts: false,
		starttime: 0,
		endtime: 0,
		duration: 0,
		viewers: 0,
		promoid: 0,
		tokens: 0,
		default_spotlight_duration: 0,
		isautoboost: 0,
		showBoostSubs: false,
		hasBoostSub: false,
		showBoostSubPromo: false,
		next_autoboost: "",
		showBoostIntroPopover: false,
		boostPopoverLearnMore: false,

		// shimmed from params
		lastpromoid: 0,
		lastpromoimpressions: 0,
		lastpromoend: 0,

		// set during session
		diff: 0,
		boosted: false,
		retries: 0,

		// calculated in the update loop
		confirming: false,
		activated: false,
		state: "",
		isbonus: false,
		now: 0,
		done: 0,
		left: 0,
		percentage: 0,
		mins: "00",
		secs: "00",
		isopen: false,
		autoboost_viewers: 0,
		autoboost_time: "",
		isrushhour: false,

		// plucked from dom
		tokenpackage: "",
		subpackage: "",
		attentionMultiplier: null,
	},

	// other stuff
	syncer: null,
	synctime: 5000,
	popoverdelay: 300,

	init(params) {
		this.Storage = BoostStorage;
		this.View = BoostView;

		// add page state overrides here!
		if (PageState.get("hasBoostSub") === true) {
			params.hasBoostSub = true;
		}

		this.set(params);
	},


	// Helpers
	// --------------------------------------------------------------------------

	getNow() {
		const now = Math.floor(new Date().getTime() / 1000);
		return now + this.data.diff;
	},

	get(name) {
		return this.data[name];
	},


	// Dev interface
	// --------------------------------------------------------------------------

	// The model uses @_set internally to set values.
	_set(name, value) {
		if (name && typeof name === "object") {
			this.data = { ...this.data, ...name };
		} else {
			this.data[name] = value;
		}
	},

	// Everything outside of this model uses @set.
	set(name, value) {
		let params;

		if (name && typeof name === "object") {
			params = name;
		} else {
			params = {};
			params[name] = value;
		}

		// shim some values
		if (params.lastpromo) {
			if (!this.checkReportSeen(params.lastpromo.id)) {
				params.lastpromoid = params.lastpromo.id;
				params.lastpromoimpressions = params.lastpromo.impressions;
				params.lastpromoend = params.lastpromo.addtime + params.lastpromo.duration;
			}
			delete params.lastpromo;
		}

		// get the difference between user and server time
		if (params.now) {
			// server time is provided in ms!
			params.now = Math.floor(params.now / 1000);
			const now = Math.floor(new Date().getTime() / 1000);
			params.diff = params.now - now;
			delete params.now;
		}

		// ANALYTICS STUFF!!!
		if ((name === "tokenpackage") && (value !== this.get(name))) {
			let price, units;
			if (BoostPackages[value]) {
				({ price, units } = BoostPackages[value]);
			}

			Analytics.logUIEvent(
				Analytics.eventNames.purchasesSelectedPlanOnBoostTokenUpsell,
				{
					data: {
						"Number of Boost tokens purchased": units,
						"Gross proceeds in local currency": price/100
					}
				}
			);
		}
		// ANALYTICS STUFF!!!

		// extend model with these values
		this._set(params);

		// get calculated values
		this.updateCalculatedValues();

		// render changes to the view
		this.View.forceRender();
	},

	checkReportSeen(promoid) {
		if (this.Storage.hasReport(promoid)) {
			// if they've already seen this report, update the sookie too
			this.setReportSeen(promoid);
			return true;
		} else {
			return false;
		}
	},

	setReportSeen(promoid) {
		promoid = promoid || this.data.lastpromoid;
		const update = { sawreport: {} };
		update.sawreport[promoid] = Math.floor(new Date().getTime() / 1000);

		this.Storage.addReport(promoid);

		// update the sookie too
		const { sookiename, sookiehash } = Context.get("boostDict");
		AjaxSookie.update(sookiename, update, 86400 * 365, sookiehash, false, true);
	},


	// Update loop
	// --------------------------------------------------------------------------

	updateCalculatedValues() {
		this.updateProgress();
		this.updateState();

		const state = this.get("state");
		this.data.isopen = (state === BOOST_STATE.Confirming) || (state === BOOST_STATE.Running) || (state === BOOST_STATE.Reporting);

		if (state === BOOST_STATE.Running) {
			this.updatePercentDone();
			this.updateMinsAndSecsLeft();
		}

		if (state === BOOST_STATE.Reporting) {
			this.updateAutoboostReport();
		}

		// if they HAVE a sub, don't SHOW the promo for it
		if (this.data.hasBoostSub) {
			this.data.showBoostSubs = false;
			this.data.showBoostSubPromo = false;
		}
	},

	updateState() {
		let newstate;
		const changed = false;

		if (!this.data.tokens) {
			// they can only be "confirming" if they have tokens
			// we're trying to confirm.
			this.data.confirming = false;
		}

		if (this.data.confirming) {
			newstate = BOOST_STATE.Confirming;

		} else if (this.data.activated) {
			newstate = BOOST_STATE.Running;

		} else if (this.data.lastpromoid) {
			newstate = BOOST_STATE.Reporting;

		} else if (this.data.tokens) {
			newstate = BOOST_STATE.ReadyToActivate;

		} else {
			newstate = BOOST_STATE.NeedingTokens;
		}

		if (this.data.state === newstate) { return; }

		this._set("state", newstate);
	},

	updateProgress() {
		// let's assume it's not activated until we discover it is
		this._set("activated", false);

		// Reset the retry status if we're not in a state where we can retry anything
		if ((this.data.state !== BOOST_STATE.Confirming) || !this.data.tokens) {
			this.data.retries = 0;
		}

		if (!this.data.starttime) {
			return;
		}

		this._set("now", this.getNow());

		// make a bundle for updating
		const u = {};

		// check how far we've come
		u.done = this.data.now - this.data.starttime;

		// check if we're in bonus time or not
		// (we're switching over shortly before the default duration is done)
		if (u.done < (this.data.default_spotlight_duration - 10)) {
			u.duration = this.data.default_spotlight_duration;
		} else {
			u.duration = this.data.duration;

			if (this.data.default_spotlight_duration < this.data.duration) {
				u.isbonus = true;
			} else {
				u.isbonus = false;
			}
		}

		u.endtime = u.duration + this.data.starttime;
		u.left = u.endtime - this.data.now;

		if (u.left < 0) {
			return;
		}

		u.activated = true;

		this._set(u);
	},

	updatePercentDone() {
		// calculate the percentage done
		let ratio = this.data.left / this.data.duration;
		ratio = ratio < 0 ? 0 : ratio;
		ratio = ratio > 1 ? 1 : ratio;
		this._set("percentage", Math.floor(ratio * 100));
	},

	updateMinsAndSecsLeft() {
		let mins = Math.floor(this.data.left / 60);
		let secs = this.data.left - (mins * 60);

		mins = mins < 10 ? `0${mins}` : mins;
		secs = secs < 10 ? `0${secs}` : secs;

		this._set("mins", mins);
		this._set("secs", secs);
	},

	updateAutoboostReport() {
		if (this.data.isautoboost && (this.data.state === BOOST_STATE.Reporting) && this.data.lastpromoend) {
			this._set("autoboost_viewers", this.data.lastpromoimpressions);
			this._set("autoboost_time", this.data.lastpromoend);
		}
	},


	// Sync with server
	// --------------------------------------------------------------------------

	autoSync() {
		clearTimeout(this.syncer);

		this.syncer = setTimeout(() => {
			this.sync();
			this.autoSync();
			this.syncBoostV2();
		}, this.synctime);
	},

	sync() {
		// this endpoint returns the list of users who
		// see you during a boost
		OkC.legacy("/json/spotlight/sync", {
			type: "POST",
			data: { spotlight: 1 },
			success: response => {
				let update = {};

				if ((response == null)) { return; }

				if (response.queue) {
					BoostViewers.updateQueue(response.queue);
				}

				if (response.modelupdate) {
					update = { ...update, ...response.modelupdate };

					const MILLISECONDS = 1000;
					getStore().dispatch(syncBoost(response.modelupdate.endtime * MILLISECONDS, response.modelupdate.starttime * MILLISECONDS));
				}

				if (response.activity) {
					BoostActivity.updateActivity(response.activity);
				}

				if (response.autoboost) {
					update.isautoboost = true;
				}

				// if we have a last promo, update all that shit
				if (isEmpty(response.modelupdate) && response.lastpromo) {
					update.lastpromoimpressions = response.lastpromo.impressions;
				}

				if (!isEmpty(update)) {
					this.set(update);
				}
			}
		});
	},

	stopSync() {
		clearTimeout(this.syncer);
	},

	syncBoostV2() {
		// this endpoint returns the boost multiplier status
		OkC.get("/boost/status", {
			api: 1,
			version: 2,
		})
		.then((resp) => {
			if (!resp) return;
			getStore().dispatch(setBoostMultiplier(resp.multiplier));
			if (!resp.isBoosting) {
				getStore().dispatch(endBoost());
			}
		})
		.catch((err) => console.error(err));
	},

	// Figure out what the hover tooltip text should be given the state.
	calculateTooltipText() {
		if (this.get('isrushhour')) {
			return _strf(`\
It’s rush hour! Boost $br
now for more action.\
`, { br: "<br/>" });

		} else if (this.get('next_autoboost')) {
			return `\
${_str("Next auto-boost:")}<br/>
${makeSmartDateString(new Date(this.get('next_autoboost') * 1000), "AUTOBOOST_TIMES")}\
`;
		}

		return null;
	},
};



// WEBPACK FOOTER //
// ./src/legacy/boosts/model.js